<div class="modal-content">
  <div class="modal-header">
    {{ copiedItem.title }}
    <i class="material-icons" (click)="onClose()">close</i>
  </div>
  <div class="modal-body">
    @if (copiedItem.numberOfResources > 0) {
      <div
        class="form-group row align-items-center"
        >
        <label class="control-label col-sm-4" for="isShaded"
          >Include Resources</label
          >
          <div class="col-sm-4">
            <div class="btn-group btn__sm">
              <label class="switch">
                <input
                  type="checkbox"
                  [checked]="includeResources"
                  (change)="includeResources = !includeResources"
                  />
                <span class="slider vPlaybookActiveToggle round"></span>
              </label>
            </div>
          </div>
        </div>
      }
      @if (copiedItem.numberOfLanguages > 0) {
        <div
          class="form-group row align-items-center"
          >
          <label class="control-label col-sm-4" for="isShaded"
            >Include Translated Content</label
            >
            <div class="col-sm-4">
              <div class="btn-group btn__sm">
                <label class="switch">
                  <input
                    type="checkbox"
                    [checked]="includeLanguages"
                    (change)="includeLanguages = !includeLanguages"
                    />
                  <span class="slider vPlaybookActiveToggle round"></span>
                </label>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn vPlaybookDefaultButton btn__btn-default"
          data-bs-dismiss="modal"
          (click)="onClose()"
          >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn__btn-default btn__orange"
          (click)="onSubmit()"
          >
          Paste
        </button>
      </div>
    </div>
